const OMAN_CITIES = ['Muscat', 'Salalah', 'Sohar', 'Nizwa', 'Sur'];
const GCC_COUNTRIES = [
  { flag: '🇦🇪', name: 'UAE' },
  { flag: '🇸🇦', name: 'Saudi Arabia' },
  { flag: '🇰🇼', name: 'Kuwait' },
  { flag: '🇧🇭', name: 'Bahrain' },
  { flag: '🇶🇦', name: 'Qatar' },
];

export default function Coverage() {
  return (
    <section className="section-padding bg-white">
      <div className="container-max">
        <div className="text-center mb-12">
          <span className="trust-badge mb-4 inline-flex">🌍 Our Reach</span>
          <h2 className="section-title-en text-3xl md:text-4xl mb-2">
            Based in Oman. Supplying the Region.
          </h2>
          <p className="section-title-ar text-2xl md:text-3xl" dir="rtl">
            مقرنا في عُمان. نزوّد المنطقة.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Oman */}
          <div className="bg-navy rounded-2xl p-8">
            <div className="flex items-center gap-3 mb-6">
              <span className="text-4xl">🇴🇲</span>
              <div>
                <h3 className="font-heading font-bold text-white text-xl">Oman</h3>
                <p className="font-arabic text-white/70 text-sm" dir="rtl">سلطنة عُمان</p>
              </div>
            </div>
            <p className="text-white/85 text-sm mb-5">
              Our home base. Fastest delivery and direct account management across all Oman cities.
            </p>
            <p className="font-arabic text-white/80 text-sm text-right mb-6" dir="rtl">
              قاعدتنا الأم. أسرع توصيل وإدارة مباشرة للحسابات في جميع مدن عُمان.
            </p>
            <div className="flex flex-wrap gap-2">
              {OMAN_CITIES.map((city) => (
                <span
                  key={city}
                  className="bg-white/10 text-white text-sm font-medium px-4 py-1.5 rounded-full border border-white/20"
                >
                  {city}
                </span>
              ))}
            </div>
          </div>

          {/* GCC */}
          <div className="bg-brand-green rounded-2xl p-8">
            <div className="flex items-center gap-3 mb-6">
              <span className="text-4xl">🌍</span>
              <div>
                <h3 className="font-heading font-bold text-white text-xl">GCC Region</h3>
                <p className="font-arabic text-white/80 text-sm" dir="rtl">منطقة الخليج</p>
              </div>
            </div>
            <p className="text-white/90 text-sm mb-5">
              Exporting to 10+ countries with proven compliance documentation for GCC import requirements.
            </p>
            <p className="font-arabic text-white/85 text-sm text-right mb-6" dir="rtl">
              نصدّر إلى أكثر من 20 دولة مع وثائق امتثال معتمدة لمتطلبات الاستيراد في دول الخليج.
            </p>
            <div className="flex flex-wrap gap-3">
              {GCC_COUNTRIES.map((c) => (
                <div
                  key={c.name}
                  className="flex items-center gap-1.5 bg-white/15 text-white text-sm font-medium px-4 py-1.5 rounded-full border border-white/25"
                >
                  <span>{c.flag}</span>
                  <span>{c.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Map embed */}
        <div className="mt-8 rounded-2xl overflow-hidden border border-gray-100 h-72 md:h-80">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3651.5!2d58.3829!3d23.5880!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e8dfb0699bf4d8d%3A0x62b6ad2edd!2sMuscat%2C%20Oman!5e0!3m2!1sen!2som!4v1700000000000!5m2!1sen!2som"
            className="w-full h-full"
            loading="lazy"
            title="omandisposables.com Location - Muscat, Oman"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
}
